import React from "react";
import { Box, Button, Icon, Menu, MenuItem } from "@showitinc/showit-wc";
import SiteInfo from "./SiteInfo";
import styles from "./Toolbar.module.css";
import When from "../../components/utils/When";
import { goToUserMcShowit } from "../../adaptors/NavigationAdaptors";
import { copyToClipboard } from "../../utils/AppUtils";
import { showAdminRestoreModal } from "../../adaptors/ModalAdaptors";
import { useAccountState } from "../../hooks/query/useAccount";
import useSite from "../../hooks/query/useSite";

const ToolbarLeft = () => {
  const user = useAccountState();
  const { site } = useSite();
  const designKey = site?.key;
  const isAdmin = user.get("isAdmin", false);
  const userId = user.get("user_id");

  return (
    <Box d="flex" align="center" className={styles.leftToolbarItem}>
      <Box
        pl="2"
        d="flex"
        align="center"
        className={styles["fixed-width-left-toolbar-logo-wrapper"]}
      >
        <When it={!isAdmin}>
          <Icon className={styles.toolbarIcon} type="logoPrimary" />
        </When>
        <When it={isAdmin}>
          <Menu py="lg" className={styles["showit-logo-menu"]}>
            <Button
              className={styles["showit-logo-button"]}
              variant="icon"
              icon-prefix="logoPrimary"
              icon-suffix="chevronDown"
              slot="trigger-element"
              popovertarget="menu"
            />
            <MenuItem title={userId} onClick={() => goToUserMcShowit(userId)}>
              View user in McShowit
            </MenuItem>
            <MenuItem
              title={designKey}
              onClick={() => copyToClipboard({ val: designKey, showToast: true, dur: 2000 })}
            >
              Copy design key
            </MenuItem>
            <MenuItem onClick={showAdminRestoreModal}>View Restore Points</MenuItem>
          </Menu>
        </When>

        <SiteInfo />
      </Box>
    </Box>
  );
};

export default ToolbarLeft;
